import { useState } from "react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { FileText, Plus, Search, Mail } from "lucide-react";

export default function MessageTemplatesPage() {
  const [searchTerm, setSearchTerm] = useState("");
  const [isNewTemplateOpen, setIsNewTemplateOpen] = useState(false);
  const [newTemplate, setNewTemplate] = useState({
    title: "",
    content: "",
    type: "email"
  });

  return (
    <div className="container mx-auto p-4 md:p-6 max-w-7xl">
      <div className="flex items-center gap-4 mb-8">
        <div className="w-12 h-12 bg-gradient-to-br from-green-500 to-green-600 rounded-lg flex items-center justify-center shadow-lg">
          <FileText className="w-6 h-6 text-white" />
        </div>
        <div>
          <h1 className="text-3xl font-bold tracking-tight">قوالب الرسائل</h1>
          <p className="text-muted-foreground mt-1">
            إدارة قوالب الرسائل والإشعارات
          </p>
        </div>
      </div>

      <div className="flex flex-col sm:flex-row gap-4 mb-6">
        <div className="relative flex-1">
          <Search className="absolute right-3 top-1/2 transform -translate-y-1/2 text-muted-foreground w-4 h-4" />
          <Input
            placeholder="البحث في القوالب..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="pr-10"
          />
        </div>
        
        <Dialog open={isNewTemplateOpen} onOpenChange={setIsNewTemplateOpen}>
          <DialogTrigger asChild>
            <Button>
              <Plus className="w-4 h-4 ml-2" />
              قالب جديد
            </Button>
          </DialogTrigger>
          <DialogContent className="max-w-2xl">
            <DialogHeader>
              <DialogTitle>إنشاء قالب جديد</DialogTitle>
              <DialogDescription>
                أنشئ قالب رسالة جديد للاستخدام في الإشعارات
              </DialogDescription>
            </DialogHeader>
            <div className="space-y-4">
              <div>
                <label className="text-sm font-medium mb-2 block">عنوان القالب</label>
                <Input
                  value={newTemplate.title}
                  onChange={(e) => setNewTemplate({ ...newTemplate, title: e.target.value })}
                  placeholder="أدخل عنوان القالب"
                />
              </div>

              <div>
                <label className="text-sm font-medium mb-2 block">محتوى الرسالة</label>
                <Textarea
                  value={newTemplate.content}
                  onChange={(e) => setNewTemplate({ ...newTemplate, content: e.target.value })}
                  placeholder="أدخل محتوى الرسالة..."
                  rows={8}
                />
              </div>

              <div className="flex gap-2 pt-4">
                <Button onClick={() => setIsNewTemplateOpen(false)}>
                  حفظ القالب
                </Button>
                <Button variant="outline" onClick={() => setIsNewTemplateOpen(false)}>
                  إلغاء
                </Button>
              </div>
            </div>
          </DialogContent>
        </Dialog>
      </div>

      <div className="grid gap-4">
        <Card>
          <CardHeader>
            <div className="flex items-start justify-between">
              <div className="flex-1">
                <CardTitle className="text-lg mb-2">تأكيد الحجز</CardTitle>
                <CardDescription>
                  قالب رسالة تأكيد الحجز للعملاء
                </CardDescription>
              </div>
              <div className="flex gap-2">
                <Badge className="bg-blue-100 text-blue-800">
                  بريد إلكتروني
                </Badge>
              </div>
            </div>
          </CardHeader>
          <CardContent>
            <p className="text-sm text-muted-foreground mb-4">
              عزيزي العميل، نشكركم لاختيار خدماتنا. تم تأكيد حجزكم بنجاح...
            </p>
            
            <div className="flex justify-end gap-2">
              <Button size="sm" variant="outline">
                تعديل
              </Button>
              <Button size="sm">
                <Mail className="w-4 h-4 ml-1" />
                معاينة
              </Button>
            </div>
          </CardContent>
        </Card>

        <Card>
          <CardHeader>
            <div className="flex items-start justify-between">
              <div className="flex-1">
                <CardTitle className="text-lg mb-2">تذكير موعد السفر</CardTitle>
                <CardDescription>
                  رسالة تذكير للعملاء قبل موعد السفر
                </CardDescription>
              </div>
              <div className="flex gap-2">
                <Badge className="bg-green-100 text-green-800">
                  رسالة نصية
                </Badge>
              </div>
            </div>
          </CardHeader>
          <CardContent>
            <p className="text-sm text-muted-foreground mb-4">
              تذكير: موعد سفركم غداً الساعة 9 صباحاً. يرجى الوصول قبل ساعتين...
            </p>
            
            <div className="flex justify-end gap-2">
              <Button size="sm" variant="outline">
                تعديل
              </Button>
              <Button size="sm">
                <Mail className="w-4 h-4 ml-1" />
                معاينة
              </Button>
            </div>
          </CardContent>
        </Card>

        <div className="text-center py-8 text-muted-foreground">
          لا توجد قوالب أخرى
        </div>
      </div>
    </div>
  );
}